module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "loading-main"
  }, [_c('div', {
    staticClass: "loading",
    class: {
      'show': _vm.isShow
    }
  }, [_c('div', {
    staticClass: "loading-gif animation_x"
  }), _vm._v(" "), _c('p', [_vm._v("loading...")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-696d3b1d"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v_loading/index.vue
// module id = 601
// module chunks = 1